import { TemplateConfig } from '../../template-config.interface';

export const GPOVALLASAutoResolutionBranded: TemplateConfig = {
  id: 'auto-resolution-branded',
  clientId: 'GPOVALLAS',
  title: 'Auto resolution branded',
  description: 'Adaptación de video vertical para pantallas en vía pública',
  aspectRatio: 'horizontal',
  image:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/auto-resolution-branded/thumbnails/auto-resolution-branded_1920x1080.png',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/auto-resolution-branded/thumbnails/optimized/auto-resolution-branded_1920x1080.png',
  video:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_1920x1080.mp4',
  video_1920x1080:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_1920x1080.mp4',
  video_1080x1920:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_1080x1920.mp4',
  video_1080x1350:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_1080x1350.mp4',
  video_1080x1080:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_1080x1080.mp4',
  video_300x250:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_300x250.mp4',
  video_300x600:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_300x600.mp4',
  video_310x482:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_310x482.mp4',
  video_400x600:
    'https://media.backend.doer.ar/brands/assets/GPOVALLAS/templates/previews/auto-resolution-branded/auto-resolution-branded_400x600.mp4',

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'videoLink',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/available-now/video.png'
    },
    {
      key: 'enableSubtitles',
      label: 'Subtítulos',
      type: 'switch',
      required: true,
      defaultValue: false
    }
  ],

  promptTemplate: `Creá todas las "resoluciones con banners/gráficas/sobreimpresos" para "https://media.backend.doer.ar/brands/assets/GPOVALLAS/examples/test.mp4"`
};
